// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iVJQuEM1ymhmEHey1lwZ {
    min-width: 0;
    color: var(--mark-text);
}
._6o4CV_EB4WWcvzRkrOkF > section {
    min-width: 0;
    max-width: 100%;
}
.PlNCRpcfNwocip_Rs0nP {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    min-width: 0;
    padding: clamp(2.4rem, 4vw, 4.8rem);
}
.WlXdIGIusoSA3dh9IlHw,
.DO5nK3UBJ2pTYCpeECfy,
.Atevz87J3CGseBg45fiQ,
.URua9yCqGoiHlR0H4iEA {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.6rem;
}
.WlXdIGIusoSA3dh9IlHw {
    align-items: flex-start;
}
.HoPsOHx3O_0cefHIRgW_ {
    flex: 1;
    min-width: min(100%, 24rem);
    overflow-wrap: anywhere;
}
.Atevz87J3CGseBg45fiQ {
    justify-content: flex-end;
}
.DO5nK3UBJ2pTYCpeECfy {
    justify-content: flex-start;
    align-items: flex-end;
    padding: 1.6rem;
    border: 0.2rem solid var(--mark-border);
    border-radius: 1.2rem;
}
.DO5nK3UBJ2pTYCpeECfy > * {
    min-width: 0;
}
.ABKJLvx08eVefSqCwkQH,
.ZcDc2WPEdGUCHI8stnRb,
.TcTPleZJl4VQ4YrhL1Od {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 2.4rem;
}
.ABKJLvx08eVefSqCwkQH fieldset {
    min-width: 0;
}
.Zr7U1XzWoGpptBLUHC7K {
    position: relative;
    width: 100%;
    min-width: 0;
}
.eT27WwQS7fReVudK1Xbl,
.nmcEjX_c41OMUqqAN3xI {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    min-width: 0;
}
.nmcEjX_c41OMUqqAN3xI {
    border: 0;
    padding: 0;
    margin: 0;
    gap: 1.2rem;
}
.Lmf7kwj3DgrR2tkkZ4T_,
.JUAUuDbXVtScwxQRtzNi,
.eEJmVz31XNi0NNSsEwq1,
.eyE_x5tmdgFwfCOzPK2R {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 24rem), 1fr));
    gap: 1.6rem;
    min-width: 0;
}
.JUAUuDbXVtScwxQRtzNi {
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 24rem), 1fr));
    gap: 1.2rem;
}
.Y8eHcJenoUFVAH2MMX6J {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    padding: 1.6rem;
    border: 0.2rem solid var(--mark-border);
    border-radius: 1.2rem;
    cursor: pointer;
    min-width: 0;
    box-sizing: border-box;
    min-height: 5.6rem;
    overflow-wrap: anywhere;
}
.Y8eHcJenoUFVAH2MMX6J:hover:not(:has(input:disabled)) {
    border-color: var(--mark-primary);
}
.Y8eHcJenoUFVAH2MMX6J:has(input:checked) {
    border-color: var(--mark-primary);
    background: var(--mark-selected);
}
.Y8eHcJenoUFVAH2MMX6J:has(input:focus-visible) {
    outline: 0.2rem solid var(--mark-primary);
    outline-offset: 0.3rem;
}
.Y8eHcJenoUFVAH2MMX6J:has(input:disabled) {
    cursor: default;
    opacity: 0.6;
}
.LXk0FYvKoWXouUFvjvlU {
    display: flex;
    gap: 0.8rem;
    overflow-x: auto;
    padding: 0.4rem 0 1.2rem;
    border-bottom: 0.2rem solid var(--mark-border);
}
.LXk0FYvKoWXouUFvjvlU > * {
    flex-shrink: 0;
}
.eEJmVz31XNi0NNSsEwq1 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 15rem), 1fr));
    list-style: none;
    padding: 0;
    margin: 0;
    gap: 0.8rem;
}
.dl5N0tQEIaDtBK4LMcCb {
    width: 100%;
    text-align: left;
}
.eEJmVz31XNi0NNSsEwq1 > li {
    display: flex;
    min-width: 0;
}
.R71lAxPsUDXU_rZuKfCQ {
    border: 0.2rem solid var(--mark-border);
    border-radius: 1.2rem;
    padding: 2.4rem;
    min-width: 0;
    overflow-wrap: anywhere;
}
.skTIDhu5Vx9Xf8c3BAY3 {
    border-radius: 1.2rem;
    padding: 1.6rem;
    min-width: 0;
    overflow-wrap: anywhere;
}
.wM_HP3k2ZRGIcAhtscfx {
    display: grid;
    grid-template-columns: minmax(12rem, 1fr) minmax(0, 2fr);
    gap: 1.2rem;
    padding: 1.2rem 0;
    border-bottom: 0.1rem solid var(--mark-border);
    overflow-wrap: anywhere;
}
.wM_HP3k2ZRGIcAhtscfx:last-child {
    border-bottom: 0;
}
.ZSjdbBILNuSkQ8d16fCb {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.2rem;
    text-align: center;
    padding: 4rem 2.4rem;
}
.KGrZRSLCtKx_OB8Iclkb {
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
}
.URua9yCqGoiHlR0H4iEA {
    padding: 1.6rem 0 0.4rem;
    border-top: 0.2rem solid var(--mark-border);
    background: var(--mark-surface);
}
@media (max-width: 600px) {
    .PlNCRpcfNwocip_Rs0nP {
        padding: 1.6rem;
    }
    .R71lAxPsUDXU_rZuKfCQ {
        padding: 1.6rem;
    }
    .wM_HP3k2ZRGIcAhtscfx {
        grid-template-columns: 1fr;
        gap: 0.4rem;
    }
    .DO5nK3UBJ2pTYCpeECfy {
        align-items: stretch;
    }
    .WlXdIGIusoSA3dh9IlHw > .Atevz87J3CGseBg45fiQ {
        width: 100%;
        justify-content: flex-start;
    }
}

.hamlpZQxGwOAVwCboT_X {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
}
.X0x7oy8sD42PgrzW4bPx {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 1.2rem;
    align-items: end;
    min-width: 0;
}
.Df9vwZqsSKTDSI8nHjjQ {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(24rem, 30rem);
    gap: 2.4rem;
    margin-top: 1.6rem;
}
.bR1glLqzYx93qKXtISTw {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.2rem;
}
@media (max-width: 900px) {
    .Df9vwZqsSKTDSI8nHjjQ {
        grid-template-columns: 1fr;
    }
}
@media (max-width: 400px) {
    .X0x7oy8sD42PgrzW4bPx,
    .bR1glLqzYx93qKXtISTw {
        grid-template-columns: 1fr;
    }
}

.OXnWnMhDWHNVxHRpcCWX {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) auto;
    gap: 1.2rem;
    align-items: end;
}
.skTIDhu5Vx9Xf8c3BAY3[role='alert'] {
    background: var(--mark-danger-surface);
    color: var(--mark-danger);
}
@media (max-width: 600px) {
    .OXnWnMhDWHNVxHRpcCWX {
        grid-template-columns: minmax(0, 1fr);
    }
}

.hePYDla7riXM21OzbtG8:focus-visible {
    outline: 0.2rem solid var(--mark-primary);
    outline-offset: 0.3rem;
}

.YMfBKgJmqvazNMy2EVCE {
    margin: 0;
    color: var(--mark-danger);
    font-size: 1.4rem;
}
.OwgwKOsEcRnvEWSzOD4U {
    min-width: min(100%, 16rem);
}
.OwgwKOsEcRnvEWSzOD4U select {
    padding-inline-end: 4rem;
}
.hKGaioDZKKM5w2LvDrzf,
.rxubcWKrH1qPgCimHYcX,
.wckmeNEBS5Etw9WLBO0h {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.2rem;
}
.hKGaioDZKKM5w2LvDrzf {
    justify-content: flex-end;
}
.hKGaioDZKKM5w2LvDrzf button {
    flex: 0 0 auto;
    min-width: max-content;
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
}
.ihioLDu1uv9AUfEEnVBU {
    white-space: nowrap;
}
.nDqxXlGqpZcuN1wmYRrU {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    color: var(--mark-text);
    font-size: 1.6rem;
    cursor: pointer;
    list-style: none;
}
.nDqxXlGqpZcuN1wmYRrU::marker {
    content: '';
}
.nDqxXlGqpZcuN1wmYRrU::-webkit-details-marker {
    display: none;
}
.nDqxXlGqpZcuN1wmYRrU::after {
    content: '';
    width: 0.7rem;
    height: 0.7rem;
    border-right: 0.2rem solid currentColor;
    border-bottom: 0.2rem solid currentColor;
    transform: rotate(45deg);
}
details[open] > .nDqxXlGqpZcuN1wmYRrU::after {
    transform: rotate(225deg);
}
.nDqxXlGqpZcuN1wmYRrU:focus-visible {
    outline: 0.2rem solid var(--mark-primary);
    outline-offset: 0.3rem;
}
.eEJmVz31XNi0NNSsEwq1 .dl5N0tQEIaDtBK4LMcCb {
    font-size: 1.6rem;
}
.eEJmVz31XNi0NNSsEwq1 .dl5N0tQEIaDtBK4LMcCb:disabled {
    opacity: 1;
}
.eEJmVz31XNi0NNSsEwq1 .dl5N0tQEIaDtBK4LMcCb:disabled:not([aria-current]) {
    color: var(--mark-text);
    background: var(--mark-surface);
}
.eEJmVz31XNi0NNSsEwq1 .dl5N0tQEIaDtBK4LMcCb:disabled[aria-current='step'] {
    color: var(--mark-text);
    background: var(--mark-selected);
    border-color: var(--mark-primary);
}
.eEJmVz31XNi0NNSsEwq1 .dl5N0tQEIaDtBK4LMcCb[data-reachable='false'] {
    border-style: dashed;
}
.eEJmVz31XNi0NNSsEwq1 .dl5N0tQEIaDtBK4LMcCb:disabled * {
    opacity: 1;
    color: inherit;
}
.EUCu5tyfDWaYrZLFMH3s {
    position: absolute;
    width: max-content;
    min-width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 0.4rem;
    list-style: none;
    background: var(--mark-surface);
    border: 1px solid var(--mark-border);
    border-radius: 0.4rem;
    overflow-y: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 10;
}
.EUCu5tyfDWaYrZLFMH3s .pXkZ0jfUiqakpAUfL_4l {
    display: block;
    width: 100%;
    height: 4.4rem;
    min-height: 4.4rem;
    box-sizing: border-box;
    padding: 0.8rem 1.2rem;
    border-radius: 0.4rem;
    white-space: nowrap;
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/components/markLayout.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mCAAmC;AACvC;AACA;;;;IAII,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,OAAO;IACP,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,eAAe;IACf,uCAAuC;IACvC,qBAAqB;AACzB;AACA;IACI,YAAY;AAChB;AACA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,WAAW;AACf;AACA;;;;IAII,aAAa;IACb,sEAAsE;IACtE,WAAW;IACX,YAAY;AAChB;AACA;IACI,sEAAsE;IACtE,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,uCAAuC;IACvC,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;IACjC,gCAAgC;AACpC;AACA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,8CAA8C;AAClD;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,sEAAsE;IACtE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,WAAW;AACf;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,uCAAuC;IACvC,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,wDAAwD;IACxD,WAAW;IACX,iBAAiB;IACjB,8CAA8C;IAC9C,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,2CAA2C;IAC3C,+BAA+B;AACnC;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,0BAA0B;QAC1B,WAAW;IACf;IACA;QACI,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,2BAA2B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,aAAa;IACb,0DAA0D;IAC1D,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,WAAW;AACf;AACA;IACI;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI;;QAEI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,yDAAyD;IACzD,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,sCAAsC;IACtC,yBAAyB;AAC7B;AACA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,wBAAwB;AAC5B;AACA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,uCAAuC;IACvC,wCAAwC;IACxC,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;AACA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,iCAAiC;AACrC;AACA;IACI,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,oCAAoC;IACpC,qBAAqB;IACrB,gBAAgB;IAChB,yCAAyC;IACzC,WAAW;AACf;AACA;IACI,cAAc;IACd,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".workspace {\n    min-width: 0;\n    color: var(--mark-text);\n}\n.modalOverlay > section {\n    min-width: 0;\n    max-width: 100%;\n}\n.page {\n    display: flex;\n    flex-direction: column;\n    gap: 2.4rem;\n    min-width: 0;\n    padding: clamp(2.4rem, 4vw, 4.8rem);\n}\n.pageHeader,\n.toolbar,\n.actions,\n.formFooter {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1.6rem;\n}\n.pageHeader {\n    align-items: flex-start;\n}\n.headerCopy {\n    flex: 1;\n    min-width: min(100%, 24rem);\n    overflow-wrap: anywhere;\n}\n.actions {\n    justify-content: flex-end;\n}\n.toolbar {\n    justify-content: flex-start;\n    align-items: flex-end;\n    padding: 1.6rem;\n    border: 0.2rem solid var(--mark-border);\n    border-radius: 1.2rem;\n}\n.toolbar > * {\n    min-width: 0;\n}\n.form,\n.stack,\n.modalContent {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    gap: 2.4rem;\n}\n.form :global(fieldset) {\n    min-width: 0;\n}\n.inputWrap {\n    position: relative;\n    width: 100%;\n    min-width: 0;\n}\n.field,\n.fieldset {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    min-width: 0;\n}\n.fieldset {\n    border: 0;\n    padding: 0;\n    margin: 0;\n    gap: 1.2rem;\n}\n.fieldGrid,\n.choiceGroup,\n.steps,\n.summaryGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(100%, 24rem), 1fr));\n    gap: 1.6rem;\n    min-width: 0;\n}\n.choiceGroup {\n    grid-template-columns: repeat(auto-fit, minmax(min(100%, 24rem), 1fr));\n    gap: 1.2rem;\n}\n.choice {\n    display: flex;\n    align-items: center;\n    gap: 1.2rem;\n    padding: 1.6rem;\n    border: 0.2rem solid var(--mark-border);\n    border-radius: 1.2rem;\n    cursor: pointer;\n    min-width: 0;\n    box-sizing: border-box;\n    min-height: 5.6rem;\n    overflow-wrap: anywhere;\n}\n.choice:hover:not(:has(input:disabled)) {\n    border-color: var(--mark-primary);\n}\n.choice:has(input:checked) {\n    border-color: var(--mark-primary);\n    background: var(--mark-selected);\n}\n.choice:has(input:focus-visible) {\n    outline: 0.2rem solid var(--mark-primary);\n    outline-offset: 0.3rem;\n}\n.choice:has(input:disabled) {\n    cursor: default;\n    opacity: 0.6;\n}\n.tabs {\n    display: flex;\n    gap: 0.8rem;\n    overflow-x: auto;\n    padding: 0.4rem 0 1.2rem;\n    border-bottom: 0.2rem solid var(--mark-border);\n}\n.tabs > * {\n    flex-shrink: 0;\n}\n.steps {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(100%, 15rem), 1fr));\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    gap: 0.8rem;\n}\n.stepButton {\n    width: 100%;\n    text-align: left;\n}\n.steps > li {\n    display: flex;\n    min-width: 0;\n}\n.panel {\n    border: 0.2rem solid var(--mark-border);\n    border-radius: 1.2rem;\n    padding: 2.4rem;\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n.notice {\n    border-radius: 1.2rem;\n    padding: 1.6rem;\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n.summaryRow {\n    display: grid;\n    grid-template-columns: minmax(12rem, 1fr) minmax(0, 2fr);\n    gap: 1.2rem;\n    padding: 1.2rem 0;\n    border-bottom: 0.1rem solid var(--mark-border);\n    overflow-wrap: anywhere;\n}\n.summaryRow:last-child {\n    border-bottom: 0;\n}\n.emptyState {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.2rem;\n    text-align: center;\n    padding: 4rem 2.4rem;\n}\n.tableScroll {\n    max-width: 100%;\n    min-width: 0;\n    overflow-x: auto;\n}\n.formFooter {\n    padding: 1.6rem 0 0.4rem;\n    border-top: 0.2rem solid var(--mark-border);\n    background: var(--mark-surface);\n}\n@media (max-width: 600px) {\n    .page {\n        padding: 1.6rem;\n    }\n    .panel {\n        padding: 1.6rem;\n    }\n    .summaryRow {\n        grid-template-columns: 1fr;\n        gap: 0.4rem;\n    }\n    .toolbar {\n        align-items: stretch;\n    }\n    .pageHeader > .actions {\n        width: 100%;\n        justify-content: flex-start;\n    }\n}\n\n.srOnly {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip-path: inset(50%);\n    white-space: nowrap;\n    border: 0;\n}\n.searchForm {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 1.2rem;\n    align-items: end;\n    min-width: 0;\n}\n.editorLayout {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(24rem, 30rem);\n    gap: 2.4rem;\n    margin-top: 1.6rem;\n}\n.durationGrid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 1.2rem;\n}\n@media (max-width: 900px) {\n    .editorLayout {\n        grid-template-columns: 1fr;\n    }\n}\n@media (max-width: 400px) {\n    .searchForm,\n    .durationGrid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.variantRow {\n    display: grid;\n    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) auto;\n    gap: 1.2rem;\n    align-items: end;\n}\n.notice[role='alert'] {\n    background: var(--mark-danger-surface);\n    color: var(--mark-danger);\n}\n@media (max-width: 600px) {\n    .variantRow {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n\n.graphStep:focus-visible {\n    outline: 0.2rem solid var(--mark-primary);\n    outline-offset: 0.3rem;\n}\n\n.fieldError {\n    margin: 0;\n    color: var(--mark-danger);\n    font-size: 1.4rem;\n}\n.segmentKindFilter {\n    min-width: min(100%, 16rem);\n}\n.segmentKindFilter :global(select) {\n    padding-inline-end: 4rem;\n}\n.confirmActions,\n.importInputActions,\n.segmentPickerActions {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n}\n.confirmActions {\n    justify-content: flex-end;\n}\n.confirmActions :global(button) {\n    flex: 0 0 auto;\n    min-width: max-content;\n    white-space: nowrap;\n    overflow: visible;\n    text-overflow: clip;\n}\n.segmentPickerAction {\n    white-space: nowrap;\n}\n.activationSummary {\n    display: flex;\n    align-items: center;\n    gap: 1.2rem;\n    color: var(--mark-text);\n    font-size: 1.6rem;\n    cursor: pointer;\n    list-style: none;\n}\n.activationSummary::marker {\n    content: '';\n}\n.activationSummary::-webkit-details-marker {\n    display: none;\n}\n.activationSummary::after {\n    content: '';\n    width: 0.7rem;\n    height: 0.7rem;\n    border-right: 0.2rem solid currentColor;\n    border-bottom: 0.2rem solid currentColor;\n    transform: rotate(45deg);\n}\n:global(details[open]) > .activationSummary::after {\n    transform: rotate(225deg);\n}\n.activationSummary:focus-visible {\n    outline: 0.2rem solid var(--mark-primary);\n    outline-offset: 0.3rem;\n}\n.steps .stepButton {\n    font-size: 1.6rem;\n}\n.steps .stepButton:disabled {\n    opacity: 1;\n}\n.steps .stepButton:disabled:not([aria-current]) {\n    color: var(--mark-text);\n    background: var(--mark-surface);\n}\n.steps .stepButton:disabled[aria-current='step'] {\n    color: var(--mark-text);\n    background: var(--mark-selected);\n    border-color: var(--mark-primary);\n}\n.steps .stepButton[data-reachable='false'] {\n    border-style: dashed;\n}\n.steps .stepButton:disabled :global(*) {\n    opacity: 1;\n    color: inherit;\n}\n.addStepMenu {\n    position: absolute;\n    width: max-content;\n    min-width: 100%;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0.4rem;\n    list-style: none;\n    background: var(--mark-surface);\n    border: 1px solid var(--mark-border);\n    border-radius: 0.4rem;\n    overflow-y: auto;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    z-index: 10;\n}\n.addStepMenu .addStepMenuItem {\n    display: block;\n    width: 100%;\n    height: 4.4rem;\n    min-height: 4.4rem;\n    box-sizing: border-box;\n    padding: 0.8rem 1.2rem;\n    border-radius: 0.4rem;\n    white-space: nowrap;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export var workspace = `iVJQuEM1ymhmEHey1lwZ`;
export var modalOverlay = `_6o4CV_EB4WWcvzRkrOkF`;
export var page = `PlNCRpcfNwocip_Rs0nP`;
export var pageHeader = `WlXdIGIusoSA3dh9IlHw`;
export var toolbar = `DO5nK3UBJ2pTYCpeECfy`;
export var actions = `Atevz87J3CGseBg45fiQ`;
export var formFooter = `URua9yCqGoiHlR0H4iEA`;
export var headerCopy = `HoPsOHx3O_0cefHIRgW_`;
export var form = `ABKJLvx08eVefSqCwkQH`;
export var stack = `ZcDc2WPEdGUCHI8stnRb`;
export var modalContent = `TcTPleZJl4VQ4YrhL1Od`;
export var inputWrap = `Zr7U1XzWoGpptBLUHC7K`;
export var field = `eT27WwQS7fReVudK1Xbl`;
export var fieldset = `nmcEjX_c41OMUqqAN3xI`;
export var fieldGrid = `Lmf7kwj3DgrR2tkkZ4T_`;
export var choiceGroup = `JUAUuDbXVtScwxQRtzNi`;
export var steps = `eEJmVz31XNi0NNSsEwq1`;
export var summaryGrid = `eyE_x5tmdgFwfCOzPK2R`;
export var choice = `Y8eHcJenoUFVAH2MMX6J`;
export var tabs = `LXk0FYvKoWXouUFvjvlU`;
export var stepButton = `dl5N0tQEIaDtBK4LMcCb`;
export var panel = `R71lAxPsUDXU_rZuKfCQ`;
export var notice = `skTIDhu5Vx9Xf8c3BAY3`;
export var summaryRow = `wM_HP3k2ZRGIcAhtscfx`;
export var emptyState = `ZSjdbBILNuSkQ8d16fCb`;
export var tableScroll = `KGrZRSLCtKx_OB8Iclkb`;
export var srOnly = `hamlpZQxGwOAVwCboT_X`;
export var searchForm = `X0x7oy8sD42PgrzW4bPx`;
export var editorLayout = `Df9vwZqsSKTDSI8nHjjQ`;
export var durationGrid = `bR1glLqzYx93qKXtISTw`;
export var variantRow = `OXnWnMhDWHNVxHRpcCWX`;
export var graphStep = `hePYDla7riXM21OzbtG8`;
export var fieldError = `YMfBKgJmqvazNMy2EVCE`;
export var segmentKindFilter = `OwgwKOsEcRnvEWSzOD4U`;
export var confirmActions = `hKGaioDZKKM5w2LvDrzf`;
export var importInputActions = `rxubcWKrH1qPgCimHYcX`;
export var segmentPickerActions = `wckmeNEBS5Etw9WLBO0h`;
export var segmentPickerAction = `ihioLDu1uv9AUfEEnVBU`;
export var activationSummary = `nDqxXlGqpZcuN1wmYRrU`;
export var addStepMenu = `EUCu5tyfDWaYrZLFMH3s`;
export var addStepMenuItem = `pXkZ0jfUiqakpAUfL_4l`;
export default ___CSS_LOADER_EXPORT___;
